(() => {
  const SELECTOR = '[data-menx-article-toc]';

  const slugify = (value) => {
    const slug = value
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 72);
    return slug || 'section';
  };

  const uniqueId = (base, usedIds) => {
    let candidate = base;
    let suffix = 2;
    while (usedIds.has(candidate) || document.getElementById(candidate)) {
      candidate = `${base}-${suffix}`;
      suffix += 1;
    }
    usedIds.add(candidate);
    return candidate;
  };

  const createMainItem = (heading, number) => {
    const item = document.createElement('li');
    item.className = 'menx-article-toc__item';
    item.dataset.level = '2';

    const link = document.createElement('a');
    link.className = 'menx-article-toc__link';
    link.href = `#${heading.id}`;
    link.dataset.menxTocTarget = heading.id;

    const badge = document.createElement('span');
    badge.className = 'menx-article-toc__number';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = String(number).padStart(2, '0');

    const text = document.createElement('span');
    text.className = 'menx-article-toc__text';
    text.textContent = heading.textContent.trim();

    const arrow = document.createElement('span');
    arrow.className = 'menx-article-toc__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';

    link.append(badge, text, arrow);
    item.appendChild(link);
    return item;
  };

  const createSubItem = (heading) => {
    const item = document.createElement('li');
    item.className = 'menx-article-toc__subitem';

    const link = document.createElement('a');
    link.className = 'menx-article-toc__sublink';
    link.href = `#${heading.id}`;
    link.dataset.menxTocTarget = heading.id;
    link.textContent = heading.textContent.trim();

    item.appendChild(link);
    return item;
  };

  const setActiveLink = (toc, id) => {
    toc.querySelectorAll('[data-menx-toc-target]').forEach((link) => {
      const active = link.dataset.menxTocTarget === id;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };

  const buildToc = (toc) => {
    if (!toc || toc.dataset.initialized === 'true') return;

    const layout = toc.closest('[data-menx-reading-layout]');
    const article = toc.closest('.article-template');
    const content = layout && layout.querySelector('.article-template__content');
    const list = toc.querySelector('[data-menx-toc-list]');
    const count = toc.querySelector('[data-menx-toc-count]');
    if (!article || !content || !list) return;

    const headings = Array.from(content.querySelectorAll('h2, h3')).filter(
      (heading) => heading.textContent.trim().length > 0
    );

    if (!headings.length) {
      toc.dataset.initialized = 'true';
      return;
    }

    const usedIds = new Set();
    headings.forEach((heading) => {
      if (!heading.id) heading.id = uniqueId(`menx-${slugify(heading.textContent)}`, usedIds);
      else usedIds.add(heading.id);
    });

    const hasH2 = headings.some((heading) => heading.tagName === 'H2');
    let mainIndex = 0;
    let currentMainItem = null;

    headings.forEach((heading) => {
      const shouldBeMain = heading.tagName === 'H2' || !hasH2;

      if (shouldBeMain) {
        mainIndex += 1;
        currentMainItem = createMainItem(heading, mainIndex);
        list.appendChild(currentMainItem);
        return;
      }

      if (!currentMainItem) return;
      let sublist = currentMainItem.querySelector('.menx-article-toc__sublist');
      if (!sublist) {
        sublist = document.createElement('ol');
        sublist.className = 'menx-article-toc__sublist';
        currentMainItem.appendChild(sublist);
      }
      sublist.appendChild(createSubItem(heading));
    });

    if (count) count.textContent = `${mainIndex} ${mainIndex === 1 ? 'section' : 'sections'}`;

    toc.hidden = false;
    toc.dataset.initialized = 'true';
    if (layout) layout.dataset.tocReady = 'true';

    toc.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;

      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      setActiveLink(toc, target.id);
      if (history.pushState) history.pushState(null, '', link.hash);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (visible.length) setActiveLink(toc, visible[0].target.id);
        },
        { rootMargin: '-18% 0px -68% 0px', threshold: 0 }
      );
      headings.forEach((heading) => observer.observe(heading));
    }
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(buildToc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
